<template>
  <div class="video-list">
    <div class="box">
      <div class="class-template" v-for="four in datas" :key="four.imgUrl" @click="goDetail">
        <img :src="four.imgUrl" alt />
        <p v-text="four.title"></p>
        <p v-text="four.source"></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: [
        {
          imgUrl: require("@/assets/boutique/dp-jy-sy16.png"),
          title: "平“语”近人",
          source: "共产党员网·2018.02.03"
        },
        {
          imgUrl: require("@/assets/boutique/dp-jy-sy17.png"),
          title: "听学新思想",
          source: "共产党员网·2018.02.03"
        }
      ]
    };
  },
  methods: {
    goDetail() {
      this.$router.push({
        path: "/boutique/videoPlayer",
        query: { title: "视频播放" }
      });
    },
  },
  name:'videoList',
};
</script>
<style lang='scss' scoped>
.video-list {
  .box {
    .class-template {
      &:nth-child(odd) {
        margin-right: 2%;
      }
      img {
        width: 100%;
      }
      p {
        &:nth-child(3) {
          color: #999999;
          font-size: 0.26rem;
        }
        line-height: 2;
        padding: 0 0.2rem;
      }
      width: 49%;
      background: #fff;
      margin-top: 0.3rem;
      padding-bottom: 0.2rem;
    }
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    padding: 0 0.2rem;
    width: 94%;
    margin: 0 auto;
    background: #fff;
    border-radius: 0.08rem;
    font-size: 0.3rem;
    min-height: 65vh;
  }
}
</style>